var React = require('react');

function SDCClose18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m10.06,9l3.62-3.62c.2-.2.2-.51,0-.71l-.35-.35c-.2-.2-.51-.2-.71,0l-3.62,3.62-3.62-3.62c-.2-.2-.51-.2-.71,0l-.35.35c-.2.2-.2.51,0,.71l3.62,3.62-3.62,3.62c-.2.2-.2.51,0,.71l.35.35c.2.2.51.2.71,0l3.62-3.62,3.62,3.62c.2.2.51.2.71,0l.35-.35c.2-.2.2-.51,0-.71l-3.62-3.62Z","fill":"#464646"}));
}

SDCClose18N.defaultProps = {"id":"Icons","viewBox":"0 0 18 18"};

module.exports = SDCClose18N;

SDCClose18N.default = SDCClose18N;
